import '../App.css'
import  './events.css';
import iconSecton from '../img/icon-section.png';
import EventsList from './eventsList';
import { useNavigate } from 'react-router-dom';


function Events() {
  const navigate = useNavigate();

  return (
    <div className="events">
      <section id="events">
        <img src={iconSecton} alt="icon-section" className="icon-section" />
        <h1>Events</h1>
      </section>
      <div className="events-intro">
        <h2></h2>
        <p></p>
      </div>
      <EventsList category="event" />
      <button
        className="button-eventsExplore"
        onClick={() => navigate('/allevents')}
      >
        <h3>全てのイベントを見る</h3>
      </button>
    </div>
  );
}

export default Events;